import React from 'react'
import PaymentCards from './components/PaymentCards'
import Address from './components/Address'
import InvoicesTable from './components/InvoicesTable'
import { NavLink } from 'react-router-dom'
import Button from '../../../components/Button'
const cards = [
  { image: '', number: '**** 6071' },
  { image: '', number: '**** 6071' },
  { image: '', number: '**** 6071' },
]
const InvoiceDataContent = ({ payments }) => {
  return (
    <div className="sm:rounded sm:p-5 border border-brd-primary overflow-hidden overflow-x-hidden mt-[10px] mb-[20px] relative w-full !min-h-[80vh] bg-secondary-background rounded p-[10px]">
      {payments.length > 0 ? (
        <div className="flex flex-col h-full w-full gap-5 justify-between">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* <PaymentCards cards={cards} /> */}
            <Address address={payments[0].user_details.adresa_client} />
          </div>
          <div>
            <InvoicesTable payments={payments} />
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-2 w-full h-full text-over-primary-background justify-center mt-10 items-center">
          <span>Nu ai făcut nicio plată până acum.</span>
          <NavLink to="/abonamente">
            <Button
              className="text-[15px] bg-btn-primary max-w-[200px] !mt-[10px]"
              onClick={() => {}}
            >
              Abonamente
            </Button>
          </NavLink>
        </div>
      )}
    </div>
  )
}

export default InvoiceDataContent
